// extracted by mini-css-extract-plugin
module.exports = {"title":"Hit_title__SIbl2"};